module.exports = __webpack_public_path__ + "img/index_lou_icon_7_on.9fbea07e.png";